import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const CTASection = ({ onJoinFree, onStartJourney }) => {
  return (
    <section className="py-12 md:py-16 lg:py-20 bg-gradient-to-br from-primary/10 via-secondary/5 to-accent/10">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6 lg:px-8">
        <div className="bg-card rounded-2xl p-8 md:p-12 lg:p-16 shadow-warm-xl text-center">
          <div className="max-w-3xl mx-auto space-y-6 md:space-y-8">
            <div className="flex items-center justify-center gap-3 mb-4">
              <div className="flex h-12 w-12 md:h-16 md:w-16 items-center justify-center rounded-full bg-gradient-to-br from-primary to-secondary shadow-warm-lg">
                <Icon name="Heart" size={24} className="md:w-8 md:h-8" color="#FFFFFF" />
              </div>
            </div>

            <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground">
              Ready to Start Your Discreet Journey?
            </h2>

            <p className="text-base md:text-lg text-muted-foreground leading-relaxed">
              Join thousands of members who trust Bamchik for secure, anonymous connections. Your privacy is guaranteed, and your journey starts today.
            </p>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6 max-w-2xl mx-auto pt-4">
              <div className="bg-success/10 rounded-xl p-4 md:p-6 text-left">
                <div className="flex items-center gap-3 mb-3">
                  <Icon name="UserPlus" size={24} color="var(--color-success)" />
                  <h3 className="text-base md:text-lg font-caption font-semibold text-success">
                    For Women
                  </h3>
                </div>
                <ul className="space-y-2 mb-4">
                  <li className="flex items-center gap-2 text-xs md:text-sm text-muted-foreground">
                    <Icon name="Check" size={14} color="var(--color-success)" />
                    <span>100% Free Forever</span>
                  </li>
                  <li className="flex items-center gap-2 text-xs md:text-sm text-muted-foreground">
                    <Icon name="Check" size={14} color="var(--color-success)" />
                    <span>Unlimited Messaging</span>
                  </li>
                  <li className="flex items-center gap-2 text-xs md:text-sm text-muted-foreground">
                    <Icon name="Check" size={14} color="var(--color-success)" />
                    <span>Full Privacy Controls</span>
                  </li>
                </ul>
                <Button
                  variant="success"
                  fullWidth
                  iconName="ArrowRight"
                  iconPosition="right"
                  onClick={onJoinFree}
                >
                  Join Free Now
                </Button>
              </div>

              <div className="bg-primary/10 rounded-xl p-4 md:p-6 text-left">
                <div className="flex items-center gap-3 mb-3">
                  <Icon name="Sparkles" size={24} color="var(--color-primary)" />
                  <h3 className="text-base md:text-lg font-caption font-semibold text-primary">
                    For Men
                  </h3>
                </div>
                <ul className="space-y-2 mb-4">
                  <li className="flex items-center gap-2 text-xs md:text-sm text-muted-foreground">
                    <Icon name="Check" size={14} color="var(--color-primary)" />
                    <span>Premium Features</span>
                  </li>
                  <li className="flex items-center gap-2 text-xs md:text-sm text-muted-foreground">
                    <Icon name="Check" size={14} color="var(--color-primary)" />
                    <span>Advanced Search Filters</span>
                  </li>
                  <li className="flex items-center gap-2 text-xs md:text-sm text-muted-foreground">
                    <Icon name="Check" size={14} color="var(--color-primary)" />
                    <span>Priority Visibility</span>
                  </li>
                </ul>
                <Button
                  variant="default"
                  fullWidth
                  iconName="ArrowRight"
                  iconPosition="right"
                  onClick={onStartJourney}
                >
                  Start Journey
                </Button>
              </div>
            </div>

            <div className="flex flex-wrap items-center justify-center gap-4 md:gap-6 pt-4 text-xs md:text-sm text-muted-foreground">
              <div className="flex items-center gap-2">
                <Icon name="ShieldCheck" size={16} color="var(--color-success)" />
                <span>SSL Encrypted</span>
              </div>
              <div className="flex items-center gap-2">
                <Icon name="Lock" size={16} color="var(--color-success)" />
                <span>Data Protected</span>
              </div>
              <div className="flex items-center gap-2">
                <Icon name="Eye" size={16} color="var(--color-success)" />
                <span>100% Anonymous</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;